var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import TagManager from "react-gtm-module";
import { logger } from "../helpers";
export var GtmPaths = {
    gdpr1: "gdpr_1",
    gdpr2: "gdpr_2",
    preparingOffer: "preparing_offer",
    wishlist: "wishlist",
    requiredHistoryPeriod: "required_history_period",
    manualScoring: "manual_scoring",
    login: "login",
    register: "register",
    expiredToken: "expired_token",
    disapproval: "disapproval",
    declined: "declined",
    deactivate: "deactivate",
    creatingCompany: "creating_company",
    contractSignedGoToApp: "contract_signed_go_to_app",
    approvedWaitingList: "approved_waiting_list",
    waitingList: "waiting_list",
    approvedMoneyRequest: "approved_money_request",
    approvedGoToApp: "approved_go_to_app",
    landingPage: "landing_page",
    pairingCompanyUrl: "pairing_company/url",
    pairingCompanyList: "pairing_company/list",
    pairingCompanyDetailPlatform: "pairing_company/detail/platform",
    pairingCompanyDetailOthers: "pairing_company/detail/others",
    accessMissingScope: "access_missing_scope",
    missingCompany: "missing_company",
    confirmationPairingCompanyPending: "confirmation_pairing_company/pending",
    confirmationPairingCompanyRejected: "confirmation_pairing_company/rejected",
    confirmationPairingCompanyReachedLimit: "confirmation_pairing_company/reached_limit",
    loanList: "loan/list",
    settingsAccount: "settings/account",
    offerAgreementSent: "offer/agreement/sent",
    offerAgreementPreparing: "offer/agreement/preparing",
    offerActiveLoanAmount: "offer/active/loan-amount",
    offerActiveContractIdentification: "offer/active/contract/identification",
    offerActiveContractBankAccount: "offer/active/contract/bankAccount",
    offerActiveContractPersonId: "offer/active/contract/person_id",
    offerActiveContractAccountStatement: "offer/active/contract/account_statement",
    offerActiveContractConfirmation: "offer/active/contract/confirmation",
    dashboardStats: "dashboard/stats",
    companyPicker: "company_picker",
    ptsd2Onboarding: "psd2_onboarding",
    ptsd2Confirmation: "psd2_confirmation",
    mobileUpload: "mobile_upload",
};
var identity = new Map();
export var GtmProvider = {
    identity: {
        set: function (key, value) {
            identity.set(key, value);
        },
        remove: function (key) {
            identity.delete(key);
        },
        clear: function () {
            identity.clear();
        },
    },
    init: function (gtmId) {
        logger.log("GtmProvider", window.dataLayer ? "Check OK" : "window.dataLayer is missing");
        if (gtmId === undefined)
            return;
        TagManager.initialize({
            gtmId: gtmId,
        });
        window.dataLayer = window.dataLayer || [];
        this.pushIdentity();
    },
    pushIdentity: function () {
        var e_1, _a;
        window.dataLayer = window.dataLayer || [];
        var data = {};
        try {
            for (var _b = __values(identity.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                data[key] = value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        logger.log("GtmProvider", "PushIdentity", data);
        window.dataLayer.push(data);
    },
    changeView: function (path, _) {
        if (_ === void 0) { _ = {}; }
        window.dataLayer = window.dataLayer || [];
        var data = {
            event: "change-view",
            changeViewPath: path,
            changeViewPayload: {}, // TODO disabled for now
        };
        logger.log("GtmProvider", "ChangeView", data);
        window.dataLayer.push(data);
    },
};
//# sourceMappingURL=gtm.provider.js.map